// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"edhRecsForm_flex__7kN2K","form":"edhRecsForm_form__jbzKz","pulse":"edhRecsForm_pulse__26hTs"};